<template>
  <div class="energy-storage-cabinet">
    <div class="cabinet">
      <div class="title">
        <span class="x-btn">
          <el-button type="text" style="color: #76defc;font-weight: bold;" icon="el-icon-back"
            @click="toDiagram">返回</el-button>
        </span>
        <span>{{buttonName}}{{currentPath1?'/'+currentPath1:''}}{{currentPath2?'/'+currentPath2:''}}</span>
      </div>
    </div>
    <div class="energy_right_title">
      <el-tabs v-model="tabChangeEquipment" class="tab-style bmsTab-style-width" type="card"
        @tab-click="tabChangeEquipments">
        <el-tab-pane v-for="(itemA, key) in equipmentNameNewX" :key="key" :label="itemA.name"
          style="position: relative;">
          <div class="imgMassage flex position_relative lineheight1" slot="label">
            <el-dropdown trigger="hover" @command="getEquipmentData" v-if="itemA.children.length" class="x-dropdown">
              <span class="el-dropdown-link spans mr_right_6" style="color: #08265F;" @click="handleClick(itemA.name)">
                <!-- {{ dropdownMenuName[key] }} -->
                {{itemA.name}}
                <i class="el-icon-caret-bottom el-icon--right" color="#e5ecf7"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="energy-menu">
                <el-dropdown-item :command="item.id" v-for="(item, index) in itemA.children" :key="index"
                  style="color:#08265F"
                  @click.native="dropdownItemClick(item,itemA.name)">{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span v-else class="spans" style="color: #08265F;">{{ itemA.name }}</span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-card class="box-card">
      <div class="e-container bms_div position_absolute">
        <div class="bms_centerDiv position_relative">
          <!-- 右边储能柜设备具体信息 -->
          <div class="energy_right position_absolute">
            <div class="energy_right_div">
              <!-- 内部具体数据 -->
              <div class="energy_right_divTop flex" :class="equipmentType === 60028 ? 'active' : ''">
                <div class="energy_right_divMore energy_right_divBlock">
                  <div class="energy_right_divTitle text-center fz-24 lineheight_32 color_bule active">
                    遥测
                  </div>
                  <div class="yc-wrap">
                    <div class="yc-header">
                      <div class="yc-col">数据项</div>
                      <div class="yc-col">数据值</div>
                      <div class="yc-col">数据项</div>
                      <div class="yc-col">数据值</div>
                    </div>
                    <div style="max-height: 65vh;overflow: auto;padding-bottom: 50px;"
                      class="energy_right_divCenterX scroll_y clearfix active_table energy_right_stretch">
                      <div class="energy_right_telemetering lineheight_32 fz-16 float_left"
                        style="position: relative;z-index:11;" :style="{'border-right-width':idx%2?0:1}"
                        v-for="(item, idx) in telemeteringX" :key="idx">
                        <div
                          style="position: absolute;top:0px;left: 0px;width:100%;height:100%;overflow: hidden;z-index: 10;"
                          :class="{ odd: idx % 4 == 0 || idx % 4 == 1 }"></div>
                        <span class="span_name displayInline_block text-center fz-0">
                          <span class="span_border lineheight_24 displayInline_block width100 position_relative">
                            <span class="span_centers fz-14">
                              {{ item.name }}
                              <span v-if="item.unit">/{{ item.unit }}</span>
                            </span>
                          </span>
                        </span>
                        <span class="span_value color_fff displayInline_block text-center fz-0">
                          <span
                            class="span_border lineheight_24 displayInline_block width100 position_relative fz-14 no_border">
                            <span class="span_centers">{{ item.value }}</span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="energy_right_divMore energy_right_divBlock">
                  <div v-if="equipmentType != '208'"
                    class="energy_right_divTitle text-center fz-24 lineheight_32 color_bule">
                    遥信
                  </div>
                  <div v-if="equipmentType != '208'" class="energy_right_divCenter scroll_y active clearfix"
                    style="width:calc(100% - 14px)">
                    <div class="energy_right_telecommand float_left" v-for="(item, idx) in telecommand" :key="idx">
                      <!-- <el-tooltip :content="item.name" placement="top"> -->
                      <div
                        :style="{height:'28px','line-height':'28px','font-size':'14px',overflow: 'hidden',background:item.color?item.color:(item.value=='0'?'#0fbb0f':'#FF3939')}"
                        class="right_telecommand text-center mr_bottom_12 color_fff">
                        {{ item.name }}
                      </div>
                      <!-- </el-tooltip> -->
                    </div>
                  </div>
                  <div v-else>
                    <yx-bms :bmsdata="bmsdata"></yx-bms>
                  </div>
                </div>
              </div>
              <div class="energy_right_divBottom" v-if="equipmentType === 60028">
                <div class="energy_right_divMore energy_right_divBlock One">
                  <div class="energy_right_divTitle text-center fz-24 lineheight_32 color_bule">
                    遥调
                  </div>
                  <div class="energy_right_divCenter scroll_y active clearfix energy_right_remote_active">
                    <div class="energy_right_remote float_left flex mr_bottom_12" v-for="(item, idx) in redeployment"
                      :key="idx">
                      <div class="right_remote_value fz-16 lineheight_32 text-center color_bule position_relative">
                        <span class="remote_value position_relative position_center">{{ item.name }}</span>
                      </div>
                      <div class="right_remote_input fz-16 lineheight_32 text-center color_fff position_relative">
                        <el-input v-model="item.value" oninput="value=value.replace(/[^(\-?)\d-]/ig,'')"></el-input>
                      </div>
                      <div class="right_remote_button fz-16 lineheight_32 text-center color_fff position_relative">
                        <a class="a displayInline_block lineheight_32 color_fff bullue_button position_relative position_centerTop cursor_pointer"
                          :class="item.isChange === 2 ? 'active' : ''" @click="changeValues(item)">
                          设置
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import {
    Loading
  } from 'element-ui';
  import API from '@/api/svolt/wiring-diagram.js';
  import ProjectLogin from '@/views/svolt/project/components/nanwang/header';
  import bms from './bms';
  export default {
    name: 'energy-storage-cabinet',
    components: {
      ProjectLogin,
      'yx-bms': bms
    },
    data() {
      return {
        currentPath1: '',
        currentPath2: '',
        loadingInstance: '',
        projectId: '',
        activeProject: 'projectHome',
        buttonName: this.$route.query.buttonName,
        options: {
          // loding拓扑图加载
          lock: true,
          text: '正在加载',
          spinner: 'el-icon-loading lodings',
          background: 'rgba(0, 0, 0, 0.7)'
        },
        rechargeDischarge: [
          // 充放电量
          {
            name: '日充电量',
            value: ''
          },
          {
            name: '日放电量',
            value: ''
          },
          {
            name: '总充电量',
            value: ''
          },
          {
            name: '总放电量',
            value: ''
          }
        ],
        pcsStart: {
          // 内部状态
          newPcsStarts: null
        },
        correspondenceStart: [
          // 通信状态
        ],
        tabChangeEquipment: 0, // 默认选项
        equipmentType: 1, // 设备类型
        equipmentNameNew: [
          // 切换
        ],
        equipmentNameNewX: [
          // 切换
        ],
        telemeteringX: [
          // 遥测信息
        ],
        telemetering: [
          // 遥测信息
        ],
        telecommand: [
          // 遥信信息
        ],
        redeployment: [
          // 遥调信息
        ],
        projectId2: '86-030000-001',
        groupId: null | sessionStorage.getItem('groupinfo'),
        energyMassage: null, // 数据
        timer: null, // 计时器请求
        setMassage: [
          // 遥调数据
        ],
        bmsdata: {
          mild: [],
          moderate: [],
          severe: []
        },
        interval: false,
        dropdownMenuName: []
      };
    },
    methods: {
      toDiagram() {
        this.$router.push({
          path: '/svolt/diagram',
          query: {
            projectId: this.$route.query.projectId
          }
        })
      },
      // 选择出来储能柜数据
      treeFilter(data) {
        let masage;
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === this.idx) {
            masage = data[i];
            break;
          }
        }
        return masage;
      },
      //切换菜单
      switchMenu(item) {
        this.activeProject = item;
        let path = this.$route.path;
        let query = {
          ...this.$route.query
        };
        query.appid = this.activeProject;
        if (item == 'projectHome') {
          query = {
            projectId: this.$route.query.projectId
          };
        }
        this.$router.push({
          path: '/svolt/project',
          query: query
        });
        let params = {
          resourceId: 186,
          projectId: this.$route.query.projectId
        };
        USERAPI.searchUserResources(params).then(res => {
          console.log(res);
          localStorage.setItem('incomeAuth', JSON.stringify(res.data.data));
        });
      },
      // 初始化
      initialize() {
        this.tabChangeEquipment = 0;
        this.telemetering = [];
        this.telecommand = [];
        this.redeployment = [];
        this.equipmentNameNew = [];
        this.pcsStart.newPcsStarts = null;
      },
      // 以服务的方式调用的 Loading 需要异步关闭
      closeLoading(loadingInstance) {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      },
      // 切换数据
      tabChangeEquipments(key, init) {
        this.currentPath1 = key.label;
        this.currentPath2 = '';
        if (key.index == 0) {
          // console.log(this.equipmentNameNewX)
          if (this.equipmentNameNewX.length) {
            this.currentPath1 = this.equipmentNameNewX[0].name
          }
        }
        key = key.index;
        let self = this;
        let idx = this.equipmentNameNewX[parseInt(key)].id;
        let types = this.equipmentNameNewX[parseInt(key)].type;
        let loadingInstance = Loading.service(self.options);

        this.equipmentType = types;
        // console.log(key,this.equipmentNameNewX[parseInt(key)].children)
        // if (this.equipmentNameNewX[parseInt(key)].children.length > 0) {
        //   idx = this.equipmentNameNewX[parseInt(key)].children[0].id;
        //   console.log(idx)
        //   if (init == true) {
        //     this.telecommand = [];
        //     this.telemetering = [];
        //     this.redeployment = [];
        //     this.getEquipmentData(idx);
        //   }
        // } else {
        this.telecommand = [];
        this.telemetering = [];
        this.redeployment = [];
        if (types == '60028') {
          this.getEquipmentData(idx, 3);
        } else {
          this.getEquipmentData(idx);
        }
        // }
        setTimeout(() => {
          self.closeLoading(loadingInstance);
        }, 300);
      },
      // 改变遥调数据
      changeValues(item) {
        let self = this;
        let range = item.range.split('~');
        let minNumber;
        let maxNumber;
        if (range.length === 1) {
          minNumber = parseInt(range[0]) - 5;
          maxNumber = parseInt(range[0]) + 5;
        } else {
          minNumber = parseInt(range[0]);
          maxNumber = parseInt(range[1]);
        }
        if (item.value <= maxNumber && item.value >= minNumber) {
          let params = {
            fields: item.field,
            projectId: this.projectId,
            sn: item.sn,
            val: item.value
          };
          API.invokeGrid(params)
            .then(res => {
              let datas = res.data.data;
              if (datas) {
                self.$notify({
                  title: '成功',
                  message: '下至成功',
                  type: 'success',
                  customClass: 'success_green',
                  iconClass: 'success_green_icon'
                });
              } else {
                self.$notify({
                  title: '失败',
                  message: '下至失败',
                  type: 'error',
                  customClass: 'error_red',
                  iconClass: 'error_red_icon'
                });
              }
            })
            .catch(function(error) {
              console.log(error);
              self.$notify({
                title: '失败',
                message: '下至失败',
                type: 'error',
                customClass: 'error_red',
                iconClass: 'error_red_icon'
              });
            });
        } else {
          let massage = item.name + '输入值请在' + minNumber + '到' + maxNumber + '区间';
          self.$notify({
            title: '提示',
            message: massage,
            type: 'warning',
            customClass: 'warning_yellow',
            iconClass: 'warning_yellow_icon'
          });
        }
      },
      //集装箱内部菜单设备接口
      equipmentchildren() {
        let self = this;
        let params = {
          equipId: 0,
          projectId: this.projectId,
          templateId: this.$route.query.templateId
        };
        API.equipmentListByTemplateId(params)
          .then(res => {
            let datas = res.data.data;
            this.equipmentNameNewX = datas;
            this.tabChangeEquipments({
              index: 0
            }, true);
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      //获取遥信遥测数据
      getEquipmentData(equipid, type) {
        console.log(equipid, type)
        this.telemeteringX = [];
        this.telemetering = [];
        this.telecommand = [];
        this.redeployment = [];
        this.dropdownMenuName = [];
        this.equipmentFieldsListByEquipIdAndDataType({
          equipid: equipid,
          datatype: 1
        });
        this.equipmentFieldsListByEquipIdAndDataType({
          equipid: equipid,
          datatype: 2
        });
        for (let i in this.equipmentNameNewX) {
          if (this.equipmentNameNewX[i].children.length > 0) {
            this.dropdownMenuName[i] = this.equipmentNameNewX[i].name;
            for (let j in this.equipmentNameNewX[i].children) {
              if (this.equipmentNameNewX[i].children[j].id == equipid) {
                this.dropdownMenuName[i] = this.equipmentNameNewX[i].children[j].name;
              }
            }
          }
        }
        //空调
        if (type) {
          this.equipmentFieldsListByEquipIdAndDataType({
            equipid: equipid,
            datatype: 3
          });
        }
      },
      handleClick(name) {
        this.dropdownMenuName = name;
        this.currentPath2 = name
      },
      dropdownItemClick(e, nameA) {
        let data = this.equipmentNameNewX;
        this.tabChangeEquipment = data.indexOf(data.filter(d => d.id == e.id)[0]) + "";
        this.equipmentType = e.type;
        console.log(e, this.equipmentType)

        this.currentPath1 = nameA
        this.currentPath2 = e.name
      },
      //获取遥信遥测接口
      equipmentFieldsListByEquipIdAndDataType(params) {
        let self = this;
        let inparams = {
          projectid: self.projectId,
          equipid: params.equipid,
          datatype: params.datatype
        };
        API.equipmentFieldsListByEquipIdAndDataType(inparams)
          .then(res => {
            if (params.datatype == 1) {
              let datas = res.data.data;
              self.telemeteringX = datas.telemetry;
            } else if (params.datatype == 2) {
              //bms
              if (this.equipmentType == '208') {
                if (res.data.data.mild) {
                  self.bmsdata.mild = res.data.data.mild;
                  self.bmsdata.moderate = res.data.data.moderate;
                  self.bmsdata.severe = res.data.data.severe;
                } else {
                  self.telecommand = [];
                }
              } else {
                let datas = res.data.data.communication;
                if (datas) {
                  if (datas.length > 0) {
                    if (self.telecommand.length === 0 || self.telecommand.length !== datas.length) {
                      self.telecommand = datas;
                    } else {
                      let datasOld = self.telecommand;
                      for (let a = 0; a < datasOld.length; a++) {
                        if (datasOld[a].id === datas[a].id && datasOld[a].value != datas[a].value) {
                          self.telecommand[a].value = datas[a].value;
                        }
                      }
                    }
                  }
                }
              }
            } else if (params.datatype == 3) {
              let datas = res.data.data.setting;
              if (datas) {
                if (datas.length > 0) {
                  if (self.redeployment.length === 0 || self.redeployment.length !== datas.lengh) {
                    for (let i = 0; i < datas.length; i++) {
                      let isChanges = datas[i];
                      let key = 'isChange';
                      let value = 1;
                      isChanges[key] = value;
                    }
                    self.redeployment = datas;
                  } else {
                    let datasOld = self.redeployment;
                    for (let a = 0; a < datasOld.length; a++) {
                      if (datasOld[a].id === datas[a].id && datasOld[a].value != datas[a].value) {
                        self.redeployment[a].value = datas[a].value;
                      }
                    }
                  }
                }
              }
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    created() {
      this.projectId = this.$route.query.projectId;
      this.activeProject = this.$route.query.appid || 'projectHome';
      this.initialize();
      this.equipmentchildren();
    },
    mounted() {}
  };
</script>

<style lang="scss" scoped>
  .energy-storage-cabinet {
    width: 100%;
    height: 100%;
    // background: url('/static/images/svolt/project-bj-01.png');
    background-color: #deeaff;
    overflow-x: hidden;
    position: absolute;
    z-index: 10;

    .cabinet {
      background-color: #fff;
      border: 0;
      margin: 0px 20px;
      padding: 10px 15px;

      .title {
        span:nth-child(1) {
          display: inline-block;
        }

        span:nth-child(2) {
          color: #76defc;
          margin-left: 13px;
          font-size: 14px;
          font-family: 'MicrosoftYaHei';
          font-weight: 400;
        }

        span:nth-child(3) {
          color: #76defc;
          font-size: 12px;
          font-family: 'MicrosoftYaHei';
          font-weight: 400;
        }
      }
    }

    .box-card {
      position: relative;
      height: calc(100% - 210px);
      margin: 10px 20px;
    }
  }
</style>
<style scoped>
  .icon-color {
    color: #e5ecf7;
  }

  /* 鼠标小手 */
  .cursor_pointer {
    cursor: pointer;
  }

  /* 相对定位 */
  .position_reactive {
    position: relative;
  }

  /* 绝对定位 */
  .position_fixed {
    position: fixed;
  }

  /* 固定定位 */
  .position_absolute {
    position: absolute;
  }

  .bmsTab-style-width {
    margin: 12px 20px !important;
  }

  .bms_div {
    z-index: 100;
    width: 100%;
    top: 0px;
    left: 0px;
    bottom: 0;
    right: 0;
  }

  .bms_div_equipment {
    height: 48px;
    line-height: 48px;
    background: rgba(17, 39, 75, 1);
    padding: 0 32px;
  }

  .bms_div_equipment .i_icon {
    color: #38a7c7;
    right: 32px;
  }

  .bms_div_backText {
    font-size: 14px;
    color: #fff;
    text-align: left;
    line-height: 30px;
    background: #1b325c;
    display: inline-block;
    height: 30px;
    padding: 0 12px;
    margin: 13px 24px 13px 0;
  }

  .color_bule {
    color: #389bc7 !important;
  }

  .bms_div_backText:hover {
    background: #e5ecf7;
  }

  .bms_div_backText .i_icon {
    margin-right: 2px;
  }

  .bms_div_backText.backText {
    font-size: 14px;
  }

  .bms_div_backText.active,
  .bms_div_backText.active:hover {
    background: rgba(0, 0, 0, 0);
    padding: 0;
  }

  .bms-div .bms-title {
    font-size: 18px;
    color: #fff;
    margin: 20px 0px 10px 20px;
  }

  .bms-div .bms-title .closebtn {
    color: #36e5ff;
  }

  .battery-pack {
    width: 47%;
    height: 286px;
    border: 1px solid #68ecff;
    margin-left: 20px;
    margin-top: 10px;
    float: left;
    overflow: auto;
  }

  .select-tab {
    margin-bottom: 20px;
    margin-left: 20px;
  }

  .temperature {
    float: right;
    margin-left: 15px;
  }

  #temperature-chart {
    width: 400px;
    height: 248px;
  }

  .battery-pack .battery-list li {
    width: 90px;
    height: 100px;
    float: left;
    list-style-type: none;
    margin-top: 26px;
  }

  .battery-pack .battery-list .battery-profile {
    position: relative;
    width: 35px;
    height: 57px;
    margin: 0 auto;
  }

  .total-precent {
    position: relative;
    width: 26px;
    height: 66%;
    margin: 10px auto;
    border-radius: 2px;
    bottom: -18px;
  }

  .power-size {
    position: absolute;
    bottom: 4px;
    width: 26px;
    color: #fff;
  }

  .proportion-size {
    position: absolute;
    top: 40%;
    font-size: 12px;
    color: #fff;
    z-index: 100;
  }

  .battery-detail {
    text-align: center;
  }

  .battery-detail span {
    display: block;
    font-size: 12px;
    color: #fff;
    margin-top: 4px;
  }

  .group-name {
    width: 100%;
    color: #fff;
    margin-left: 20px;
    margin-top: 10px;
  }

  .bms_centerDiv {
    width: 100%;
    height: 100%;
  }
</style>

<style scoped>
  .yc-wrap {
    height: calc(100% - 52px);
    overflow-y: hidden;
    padding-bottom: 20px;
  }

  .yc-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 0px;
    border: 1px solid #e5ecf7;
    border-bottom: 0px;
    background: #7CADF0;
    overflow: hidden;
  }

  .yc-col {
    width: 25%;
    float: left;
    color: #FFFFFF;
    font-size: 14px;
  }

  .odd {
    background: #EFF5FF;
    opacity: 0.5;
  }

  .el-dropdown-menu {}

  /* 储能柜 */
  .energy_left,
  .energy_right {
    top: 0;
    bottom: 0;
  }

  .energy_left {
    width: 480px;
    left: 0;
    border-right: 1px solid #e5ecf7;
  }

  .energy_right {
    width: 100%;
    padding: 0px 0px;
    right: 0;
  }

  .energy_left_top {
    height: 215px;
    padding: 40px 20px;
    border-bottom: 1px solid #e5ecf7;
  }

  .energy_left_topDiv {
    height: 100px;
  }

  .energy_left_topDiv .img {
    width: 100px;
  }

  .energy_left_topDiv .energy_leftMassage {
    width: calc(100% - 112px);
  }

  .energy_left_topDiv .energy_leftMassage .span_left {
    width: 110px;
  }

  .energy_left_topDiv .energy_leftMassage .span_center {
    min-width: 120px;
  }

  .energy_left_topDiv .energy_leftMassage .span_right {
    width: 40px;
  }

  .energy_left_center {
    height: 440px;
    padding: 20px 0;
    border-bottom: 1px solid #e5ecf7;
  }

  .diagramPower_img .img {
    width: 120px;
  }

  .diagramPower_img .img_cell {
    width: 65px;
  }

  .wiring_diagramPower_trees .equipment_data {
    left: auto;
    right: -70px;
  }

  .wiring_diagramPower_trees .equipment_data.active {
    right: -136px;
  }

  .energy_left_bottom {
    height: calc(100% - 655px);
    padding: 20px 20px 0 20px;
  }

  .energy_left_bottomMassage {
    height: calc(100% - 24px);
    padding: 20px 20px 0 20px;
  }

  .energy_left_bottomMassage .li {
    width: calc(50% - 2px);
    padding-left: 36px;
    margin: 0 auto 8px auto;
    padding-right: 10px;
    border-radius: 4px;
  }

  .energy_left_bottomMassage .li:after {
    content: '';
    height: 16px;
    width: 16px;
    border-radius: 2px;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translate(0, -50%);
    background: #0fbb0f;
  }

  .energy_left_bottomMassage .li.active:after {
    background: #ff3939;
  }

  .energy_left_bottomMassage .li:last-child {
    margin-bottom: 30px;
  }

  .energy_right_div {
    height: calc(100% - 15px);
    margin: 0px;
    padding: 0px;
    overflow: auto;
  }

  .energy_right_div .energy_right_divTop {
    /* height: calc(100% -100px); */
  }

  .energy_right_div .energy_right_divTop.active {
    height: calc(100% - 320px);
  }

  .energy_right_div .energy_right_divBlock {
    border: 0px solid #162a4f;
  }

  .energy_right_div .energy_right_divMore {
    width: calc(50% - 10px);
    height: calc(100% - 20px);
    margin-left: 10px;
  }

  .energy_right_div .energy_right_divMore.One {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
  }

  .energy_right_div .energy_right_divBottom {
    height: 320px;
  }

  .energy_right_div .energy_right_divTitle {
    padding: 10px;
    margin: 0px;
    border-bottom: 0px solid #e5ecf7;
    color: #1C6ED5;
    /* background: #eff5ff; */
    /* font-size: 18px; */
    font-weight: bold;
    font-family: 微软雅黑;
  }

  .energy_right_div .energy_right_divTitle.active {
    border-bottom: 0;
  }

  .energy_right_div .energy_right_divCenter {
    height: calc(100% - 52px);
  }


  .energy_right_div .energy_right_divCenter.active {
    background: #EFF5FF;
    padding: 12px 0px 0 0px;
  }

  .energy_right_div .energy_right_divCenterX {
    height: 100%;
    overflow: revert;
  }

  .energy_right_div .energy_right_divCenterX.active_table {
    padding: 0px;
  }

  .energy_right_div .energy_right_divCenterX.active {
    padding: 12px 10px 0 10px;
  }

  /* 遥测信息 */
  .energy_right_stretch {
    display: grid;
    align-items: stretch;
    grid-template-columns: 50% 50%;
    grid-auto-rows: min-content;
  }

  .energy_right_div .energy_right_telemetering,
  .energy_right_div .energy_right_telemetering .span_border {
    border-right: 1px solid #e5ecf7;
  }

  .energy_right_div .energy_right_telemetering .no_border {
    border-right: 0px solid #e5ecf7;
  }

  .energy_right_div .energy_right_telemetering .span_name,
  .energy_right_div .energy_right_telemetering .span_unit,
  .energy_right_telemetering .span_value {
    height: 100%;
    line-height: 1;
    position: relative;
    z-index: 99;
  }

  .energy_right_div .energy_right_telemetering .span_centers {
    font-size: 18px;
    font-family: MicrosoftYaqiHei;
    font-weight: bold;
    color: #1C6ED5;
    display: block;
    position: relative;
    width: 100%;
    top: 50%;
    transform: translate(0, -50%);
  }

  .energy_right_div .energy_right_telemetering .fz-14 {
    font-size: 16px;
    font-family: PingFang;
    font-weight: 400;
    color: #222529;
  }

  .energy_right_div .energy_right_telemetering .span_border {
    height: 100%;
  }

  .energy_right_div .energy_right_telemetering {
    width: 100%;
    border-bottom: 0px solid #e5ecf7;
    height: 100%;
    flex-flow: wrap-reverse;
    display: flex;
  }

  .energy_right_div .energy_right_telemetering:after {
    content: '';
    vertical-align: middle;
  }

  .energy_right_div .energy_right_telemetering:nth-child(1),
  .energy_right_div .energy_right_telemetering:nth-child(2) {
    border-top: 0px solid #e5ecf7;
  }

  .energy_right_div .energy_right_telemetering:nth-child(1n) {
    border-left: 0px solid #e5ecf7;
  }

  .energy_right_div .energy_right_telemetering .span_name,
  .energy_right_div .energy_right_telemetering .span_value {
    width: 50%;
    min-height: 38px;
  }

  .energy_right_div .energy_right_telemetering .span_value {
    font-size: 21px;
    font-family: MicrosoftYaqiHei-Bold, MicrosoftYaqiHei;
    font-weight: bold;
    color: #08265F;
    display: inline-block;
  }

  .energy_right_div .energy_right_telecommand {
    width: 33.3%;
    padding: 0 10px;
  }

  .energy_right_div .energy_right_telecommand .right_telecommand {
    border-radius: 2px;
  }

  .energy_right_remote_active {
    display: grid;
    align-items: stretch;
    grid-template-columns: 33.33% 33.33% 33.33%;
    grid-auto-rows: min-content;
  }

  .energy_right_div .energy_right_remote {
    width: 100%;
    padding: 0 5px;
  }

  .energy_right_div .energy_right_remote .right_remote_value {
    width: calc(100% - 10px);
    padding: 0 5px;
  }

  .energy_right_div .energy_right_remote .right_remote_value .remote_value {
    display: block;
    width: 100%;
  }

  .energy_right_div .energy_right_remote .right_remote_input {
    width: calc(100% - 10px);
    padding: 0 10px;
  }

  .energy_right_div .energy_right_remote .right_remote_input>>>.el-input {
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
  }

  .energy_right_div .energy_right_remote .right_remote_button {
    width: 60px;
    padding: 0 5px;
  }

  .energy_right_div .energy_right_remote .right_remote_button .a {
    width: 50px;
    border-radius: 2px;
  }

  .energy_right_div .energy_right_remote .right_remote_button .a:hover {
    background: #79d7ff;
    border-color: #79d7ff;
  }

  .energy_right_div .energy_right_remote .right_remote_button .a.active {
    pointer-events: none;
    cursor: default;
    background: #999;
  }

  .energy_right_div .energy_right_remote>>>.el-input__inner,
  .energy_right_div .energy_right_remote>>>.el-input__inner:hover {
    background: transparent;
    border: 1px solid #389BC7;
    padding: 0 16px;
    height: 32px;
    color: #333;
    font-size: 16px;
  }

  .bmsTab-style-width>>>.el-tabs__header {
    margin-bottom: 0px !important;
  }

  /* 导航栏 */
  .bmsTab-style-width.tab-style>>>.el-tabs__item.is-active,
  .bmsTab-style-width.tab-style>>>.el-tabs__item {
    margin-bottom: 0px;
    padding: 12px 24px;
    padding-right: 30px;
    font-size: 20px;
    /* line-height: 1; */
    background: #7CAEF2;
    color: #fff;
    position: relative;
    margin-right: 7px;
    width: 105px;
  }

  .bmsTab-style-width.tab-style>>>.el-tabs__item:last-child:after {
    width: 0;
  }

  /* .bmsTab-style-width.tab-style>>>.el-tabs__item:after {
  content: '';
  height: 24px;
  width: 2px;
  background: #aabbd8;
  position: absolute;
  right: -2px;
  top: 50%;
  transform: translate(0, -50%);
} */

  .bmsTab-style-width.tab-style>>>.el-tabs__item.is-active,
  .bmsTab-style-width.tab-style>>>.el-tabs__item:hover {
    font-weight: 500;
    background: #1C6ED5;
  }

  .bmsTab-style-width.tab-style>>>.el-tabs__nav {
    display: flex;
  }

  .bmsTab-style-width.tab-style>>>.el-tabs__item .spans {
    color: #fff !important;
    font-size: 16px;
  }

  .bmsTab-style-width.tab-style>>>.el-tabs__nav-wrap {
    /* background: #eff5ff; */
  }

  .bmsTab-style-width.tab-style>>>.el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #e5ecf7;
  }

  .bmsTab-style-width.tab-style>>>.el-tabs__active-bar {
    height: 0;
  }

  .checkout {
    padding: 20px 0;
  }

  .imgMassage {
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: row;
    height: auto;
  }

  .imgMassage .image {
    height: 36px;
  }

  .energy-menu {
    margin-top: 20px;
    background-color: #e5ecf7 !important;
    color: #ffffff !important;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #eff5ff;
  }

  .el-popper[x-placement^='bottom']>>>.popper__arrow::after {
    display: none;
  }

  .el-popper[x-placement^='bottom']>>>.popper__arrow {
    display: none;
  }

  .fz-24 {
    font-size: 18px;
  }

  .x-dropdown {
    position: relative;
  }

  .energy-storage-cabinet>>>.el-card__body {
    padding: 0px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/svolt/project/wiring-diagram/energy-storage-cabinet.vue